module.exports = __webpack_public_path__ + "img/14.7cd9cf6b.jpg";